import { render } from "./Preloader.vue?vue&type=template&id=c5c63170"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ad\\Downloads\\internship-project-todolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__